<div class="modal-header">
    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button> -->
</div>
<div class="transfer-popup error-popup">
    <div class="content">
        <h2>משהו השתבש לנו</h2>
        <p>משהו השתבש לנו, אפשר לנסות להקליד את הכרטיס בשנית או לנסות מאוחר יותר</p>
        <div class="button-wrapper">
            <a (click)="next(NextMode.Button)" class="brand-button aqua-button" title="" id="retry"
                ><span>אני רוצה לנסות שוב </span></a
            >
            <a (click)="next(NextMode.Link)" class="link" title=""><span> אני אנסה מאוחר יותר </span></a>
        </div>
    </div>
</div>
